import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GenericCategoriesApi } from "apis/GenericCategoriesApi";
import { GenericCategoryView } from "models/dbModels/genericCategories/GenericCategory";

type GetGenericCategoriesParams = {
    keyword?: string;
    offset?: number;
    limit?: number;
}

export const getGenericCategories = createAsyncThunk("genericCategoriesSlice/getGenericCategories", async (params: GetGenericCategoriesParams) => {
    const response = await GenericCategoriesApi.Search(params);
    return response.data;
});

type InitialStateType = {
    stockList: any[];
    selectedRows: any[];
    deselectedRows: any[];
    selectedgenericCategoriesStock: any[];
    loading: boolean;
    selectAllFilter: boolean;
    keyword: string;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    error: string;
    table: GenericCategoryView[]
}
const initialState: InitialStateType = {
    stockList: [],
    selectedRows: [],
    deselectedRows: [],
    selectedgenericCategoriesStock: [],
    loading: false,
    selectAllFilter: false,
    keyword: "",
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    error: "",
    table: []
}

const storesTablesSlice = createSlice({
    name: "genericCategoriesSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        cleanGenericCategoriesDetails: (state) => {
            return {
                ...state,
                ...initialState,
            };
        },
        updateGenericCategoriesField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
            state.selectedRows[action.payload.index] = action.payload.rows;
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedRows[action.payload.index] = action.payload.rows;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getGenericCategories.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];
            state.totalRows = action.payload.totalRows;
            state.totalPages = Math.ceil(Math.ceil(action.payload.totalRows) / state.pageSize);
            state.loading = false;
        });
        builder.addCase(getGenericCategories.pending, (state) => {
            state.loading = true;
            state.table = [];
            state.stockList = [];
            state.error = "";
        });
        builder.addCase(getGenericCategories.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
    },
});

export const { addDeselectedRows, addSelectedRows, cleanGenericCategoriesDetails, updateGenericCategoriesField } = storesTablesSlice.actions;

export default storesTablesSlice.reducer;

